import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class CrudUtilService {
    private sufixoForm = '_FORM-DATA';
    private sufixoResultadoObtido = '_RESULTADO-OBTIDO-DATA';

    private map;

    constructor() {
        this.map = new Map();
    }

    private setItem(key: string, data: any) {
        try {
            this.map.set(key, data);
        } catch (error) {
            console.error('Erro ao guardar dados do component ' + key + ': ' + error);
        }
    }

    private getItem(key: string): any {
        let data = null;
        try {
            data = this.map.get(key);
            this.map.delete(key);
        } catch (error) {
            console.error('Erro ao obter dados do component ' + key + ': ' + error);
        }
        return data;
    }

    public guardarFormSubmetido(keyNomeComponent: string, form: FormGroup) {
        this.setItem(keyNomeComponent + this.sufixoForm, form);
    }

    public obterFormSubmetido(keyNomeComponent: string): FormGroup {
        return this.getItem(keyNomeComponent + this.sufixoForm);
    }

    public guardarResultadoObtido(keyNomeComponent: string, resultado: any[]) {
        this.setItem(keyNomeComponent + this.sufixoResultadoObtido, resultado);
    }

    public obterResultadoObtido(keyNomeComponent: string): any[] {
        return this.getItem(keyNomeComponent + this.sufixoResultadoObtido);
    }

    public guardarEstadoPosConsulta(keyNomeComponent: string, form: FormGroup, resultado: any[]) {
        this.guardarFormSubmetido(keyNomeComponent, form);
        this.guardarResultadoObtido(keyNomeComponent, resultado);
    }

    public obterEstadoPosConsulta(keyNomeComponent: string): {
        formSubmetido: FormGroup;
        resultadoObtido: any[];
    } {
        return {
            formSubmetido: this.obterFormSubmetido(keyNomeComponent),
            resultadoObtido: this.obterResultadoObtido(keyNomeComponent)
        };
    }
}
